export default __webpack_public_path__ + "static/media/copy.d622c730.frag";